import { render, staticRenderFns } from "./PagePagination.vue?vue&type=template&id=7a0c52e7&scoped=true"
import script from "./PagePagination.vue?vue&type=script&lang=js"
export * from "./PagePagination.vue?vue&type=script&lang=js"
import style0 from "./PagePagination.vue?vue&type=style&index=0&id=7a0c52e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0c52e7",
  null
  
)

export default component.exports